var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriple888(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.702,
    height: 48,
    viewBox: "0 0 137.702 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-150 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(150 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(18.479 24.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M214.477,545.912a.549.549,0,0,1,.036-.052,7.982,7.982,0,0,0,1.059-3.593,20.207,20.207,0,0,0,5.61,3.1,7.117,7.117,0,0,0,.819.264,8,8,0,1,0,8.058-.032,12.934,12.934,0,0,0,4.485-1.995c.293-.215.559-.429.8-.637a13.33,13.33,0,1,1-22.487,11.415l.005-.005A13.561,13.561,0,0,1,214.477,545.912Z",
    transform: "translate(-212.73 -542.266)",
    fill: "#009dd3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M111.452,395.7a.046.046,0,0,0,0-.008,14.265,14.265,0,0,1,5.879,4.732c.08.19.168.378.259.557.126.2.242.414.359.622a8,8,0,0,0,13.662-.308,8,8,0,1,0-14.922-4.085,13.414,13.414,0,0,0-4.934-3.144,13.332,13.332,0,1,1,24.482,9.893c-.12.2-.235.4-.366.59-.018.036-.042.065-.066.1-.109.154-.208.311-.316.464-.018.025-.042.051-.061.076-.118.157-.232.313-.354.461-.009.015-.026.03-.035.045-.133.158-.264.317-.4.47-.007,0-.008.013-.017.019-.143.161-.288.318-.438.469v0a14.315,14.315,0,0,1-1.487,1.3,13.333,13.333,0,0,1-19.374-3.694c-.122-.192-.23-.389-.34-.592-.046-.083-.091-.161-.13-.244l-.013.03a7.982,7.982,0,1,0-2.424,11.325c-1.018,3.17-.623,5.1-.32,5.936a13.331,13.331,0,1,1,1.355-25.023Z",
    transform: "translate(-92.9 -383.961)",
    fill: "#009dd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(205.909 46.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M465.818,491.3h-1.582v-3.26H461.6v9.59h1.677v1.6H458v-1.6h1.677v-9.59h-2.637v3.26h-1.583v-4.861h10.362Z",
    transform: "translate(-455.456 -486.232)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M528.657,512.446h-1.79V510.9h3.184v2h.037a3.014,3.014,0,0,1,2.807-2.148h1.15v1.771H533.1c-2.054,0-2.676,1.15-2.676,3.184v2.544h1.922v1.545H526.9v-1.545h1.752Z",
    transform: "translate(-515.855 -506.794)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M578.563,490.849H577.15V489.3h3.184v7.348h1.413V498.2h-4.6v-1.545h1.413Zm1.9-4.578a1.055,1.055,0,1,1-1.055-1.056A1.053,1.053,0,0,1,580.466,486.271Z",
    transform: "translate(-558.384 -485.197)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M607.419,512.446h-1.488V510.9h3.259V512.3h.038a3.835,3.835,0,0,1,3.09-1.545,4.324,4.324,0,0,1,4.352,4.635,4.448,4.448,0,0,1-4.371,4.672,4.4,4.4,0,0,1-3.109-1.356v3.542H610.9v1.544H605.8v-1.544h1.62Zm4.541,6.01a2.866,2.866,0,0,0,2.882-3.147,2.828,2.828,0,0,0-2.788-3.014,2.97,2.97,0,0,0-2.9,3.165A2.8,2.8,0,0,0,611.96,518.456Z",
    transform: "translate(-582.615 -506.794)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M681.076,487.984h-1.583v-1.545h3.354v11.248h1.375v1.545h-4.767v-1.545h1.62Z",
    transform: "translate(-644.914 -486.232)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M714.394,515.161a2.933,2.933,0,0,0,3.052,2.732,3.469,3.469,0,0,0,2.883-1.451l1.545.678a5.134,5.134,0,0,1-4.465,2.317,4.713,4.713,0,1,1-.282-9.42,4.8,4.8,0,0,1,4.748,5.143Zm5.69-1.281a3.031,3.031,0,0,0-2.921-2.449,2.738,2.738,0,0,0-2.713,2.449Z",
    transform: "translate(-672.822 -506.175)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M795.925,488.45c0-2.016,1.6-3.353,4.032-3.353,2.524,0,4.126,1.3,4.126,3.353a3.309,3.309,0,0,1-1.865,2.958,3.227,3.227,0,0,1,2.261,3.165c0,2.28-1.714,3.73-4.371,3.73-3.26,0-4.578-1.733-4.578-3.73a3.245,3.245,0,0,1,2.28-3.165A3.294,3.294,0,0,1,795.925,488.45Zm6.669,6.048c0-1.431-1.017-2.317-2.656-2.317a2.3,2.3,0,0,0-2.524,2.317,2.607,2.607,0,0,0,5.181,0Zm-.245-5.878c0-1.281-.848-2-2.392-2-1.432,0-2.3.753-2.3,2.016s.9,2.053,2.356,2.053A2.049,2.049,0,0,0,802.349,488.62Z",
    transform: "translate(-743.087 -485.097)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M862.078,488.45c0-2.016,1.6-3.353,4.032-3.353,2.525,0,4.126,1.3,4.126,3.353a3.308,3.308,0,0,1-1.865,2.958,3.227,3.227,0,0,1,2.261,3.165c0,2.28-1.714,3.73-4.371,3.73-3.26,0-4.578-1.733-4.578-3.73a3.245,3.245,0,0,1,2.28-3.165A3.3,3.3,0,0,1,862.078,488.45Zm6.67,6.048c0-1.431-1.017-2.317-2.657-2.317a2.294,2.294,0,0,0-2.524,2.317,2.607,2.607,0,0,0,5.181,0Zm-.245-5.878c0-1.281-.848-2-2.393-2-1.432,0-2.3.753-2.3,2.016s.9,2.053,2.355,2.053A2.049,2.049,0,0,0,868.5,488.62Z",
    transform: "translate(-799.04 -485.097)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M928.232,488.45c0-2.016,1.6-3.353,4.032-3.353,2.524,0,4.126,1.3,4.126,3.353a3.309,3.309,0,0,1-1.865,2.958,3.228,3.228,0,0,1,2.261,3.165c0,2.28-1.715,3.73-4.371,3.73-3.259,0-4.578-1.733-4.578-3.73a3.245,3.245,0,0,1,2.279-3.165A3.294,3.294,0,0,1,928.232,488.45Zm6.67,6.048c0-1.431-1.017-2.317-2.656-2.317a2.3,2.3,0,0,0-2.525,2.317,2.607,2.607,0,0,0,5.181,0Zm-.245-5.878c0-1.281-.848-2-2.392-2-1.432,0-2.3.753-2.3,2.016s.9,2.053,2.355,2.053A2.049,2.049,0,0,0,934.656,488.62Z",
    transform: "translate(-854.992 -485.097)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M470.277,607.984h1.582v1.13c.811,1.375,1.753,2.11,2.977,2.11a2.152,2.152,0,0,0,2.261-2.148c0-2.506-4.013-1.639-6.01-3.636a3.159,3.159,0,0,1-.848-2.317,3.436,3.436,0,0,1,3.731-3.5,4.684,4.684,0,0,1,2.863,1v-.848h1.583v3.863h-1.583v-.885a3.061,3.061,0,0,0-2.713-1.489c-1.3,0-2.148.66-2.148,1.64a1.553,1.553,0,0,0,.433,1.092c1,1,4.07.829,5.558,2.317a3.972,3.972,0,0,1,1.093,2.751,3.815,3.815,0,0,1-4.05,3.768,4.528,4.528,0,0,1-3.147-1.262v1.054h-1.582Z",
    transform: "translate(-467.959 -581.959)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M531.666,609.927h1.149v-1.375l1.771-1.6v2.977h1.64v1.545h-1.64v5.144c0,.867.773.829,1.64.527v1.583a4.52,4.52,0,0,1-1.3.245,1.872,1.872,0,0,1-2.11-2.11v-5.388h-1.149Z",
    transform: "translate(-519.914 -588.159)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M575.9,635.146h-3.3v-1.017a4.833,4.833,0,0,1-2.9,1.168c-1.62,0-2.468-.886-2.468-2.751V627.8H565.97v-1.545H569v6.2c0,.9.377,1.3,1.055,1.3a4.285,4.285,0,0,0,2.543-1.131V627.8h-1.526v-1.545h3.3V633.6H575.9Z",
    transform: "translate(-548.928 -604.486)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M643.822,613.754H640.43v-1.319a4.092,4.092,0,0,1-3.165,1.469,4.292,4.292,0,0,1-4.371-4.559A4.5,4.5,0,0,1,637.3,604.6a4.168,4.168,0,0,1,3.128,1.432v-3.523h-1.7v-1.545H642.2v11.248h1.62Zm-6.236-1.394a2.91,2.91,0,0,0,2.845-3.146,2.8,2.8,0,0,0-2.864-3.014,2.884,2.884,0,0,0-2.788,3.09A2.806,2.806,0,0,0,637.586,612.36Z",
    transform: "translate(-605.532 -583.094)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M708.318,605.374h-1.413v-1.545h3.184v7.348H711.5v1.544h-4.6v-1.544h1.413Zm1.9-4.578a1.055,1.055,0,1,1-1.055-1.055A1.053,1.053,0,0,1,710.221,600.8Z",
    transform: "translate(-668.13 -582.062)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M744.094,624.541a4.71,4.71,0,1,1-4.691,4.71A4.576,4.576,0,0,1,744.094,624.541Zm-.019,7.724a3.023,3.023,0,1,0-2.789-3.014A2.843,2.843,0,0,0,744.076,632.266Z",
    transform: "translate(-695.616 -603.038)",
    fill: "#7b7d83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M806.9,631.267h1.564v.3c.151.885.96,1.432,2.129,1.432,1.112,0,1.828-.433,1.828-1.111,0-1.659-3.128-.6-4.823-2.3a2.437,2.437,0,0,1-.7-1.7c0-1.526,1.319-2.619,3.128-2.619a4.592,4.592,0,0,1,2.167.509v-.358h1.545v2.939h-1.545v-.547a2.311,2.311,0,0,0-2.073-1.092c-.942,0-1.563.434-1.563,1.092,0,1.489,3.429.623,4.9,2.092a2.622,2.622,0,0,1,.754,1.846c0,1.621-1.375,2.713-3.41,2.713a3.969,3.969,0,0,1-2.336-.641v.49H806.9Z",
    transform: "translate(-752.704 -603.659)",
    fill: "#7b7d83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriple888);
export default __webpack_public_path__ + "static/media/triple888.38732025549670f943363637c207de7f.svg";
export { ForwardRef as ReactComponent };